import { render, staticRenderFns } from "./LocalInventoryMgmt.vue?vue&type=template&id=1cda5f02"
import script from "./LocalInventoryMgmt.vue?vue&type=script&lang=js"
export * from "./LocalInventoryMgmt.vue?vue&type=script&lang=js"
import style0 from "./LocalInventoryMgmt.vue?vue&type=style&index=0&id=1cda5f02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports